import {
  TYPE_SUBSCENE_GIF,
  TYPE_SUBSCENE_IMAGE,
  TYPE_SUBSCENE_TEXT,
  TYPE_SUBSCENE_TEXT_BOX,
  TYPE_SUBSCENE_VIDEO
} from "./type-subscene";
import {decompressFrames, parseGIF} from "gifuct-js";
import {FRAME_TIME} from "../lib/nodes/giff-node";

export const getMaxFullSize = (width, height, originAreaWidth = 16, originAreaHeight = 9, coeffWidth = 1, coeffHeight = 1) => {
    const areaWidth = originAreaWidth * coeffWidth;
    const areaHeight = originAreaHeight * coeffHeight;
    const calculatedAreaHeight = height * areaWidth / width;

    if (calculatedAreaHeight > areaHeight) {
        // height ratio bigger the areaHeight
        const pWidth = 1 / ((areaWidth/areaHeight)/(width/height));
        return {
            Width: pWidth * coeffWidth,
            Height: coeffHeight
        }
    } else if (calculatedAreaHeight < areaHeight) {
        // height ratio smaller then areaHeight
        const pHeight = (areaWidth/areaHeight)/(width/height)
        return {
            Width: coeffWidth,
            Height: pHeight * coeffHeight,
        }
    } else {
        // image ratio as out = areaWidth:areaHeight
        return {
            Width: coeffWidth,
            Height: coeffHeight
        }
    }
}

export const getImage = url => new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => {
        resolve(image)
    }
    image.onerror = reject;
    image.src = url;
})

export const getSizeOfImgUrl = async url => {
    const { width, height } = await getImage(url);
    return [ width, height ]
}

export const getSizeOfVideoUrl = url => new Promise((resolve, reject) => {
    const video = document.createElement('video');
    video.onloadedmetadata = () => {
        resolve([
            video.videoWidth,
            video.videoHeight,
        ]);
    }
    video.onerror = reject;
    video.src = url;
})

const getResolutionFetcher = type => {
    switch (type) {
        case TYPE_SUBSCENE_IMAGE:
        case TYPE_SUBSCENE_TEXT:
        case TYPE_SUBSCENE_TEXT_BOX:
        case TYPE_SUBSCENE_GIF:
            return getSizeOfImgUrl;
        case TYPE_SUBSCENE_VIDEO:
            return getSizeOfVideoUrl;
        default:
            throw new Error(`Scene type ${type} has no resolution handler. You can implement one in image-calculation.js`)
    }
}

export const getMaxFullSizeFromUrl = async (url, type, ...args) => {
    const resolutionFetcher = getResolutionFetcher(type);
    return getMaxFullSize(...(await resolutionFetcher(url)), ...args)
}

const calculateGifTime = frames => frames.reduce((time, frame) => (frame.delay || FRAME_TIME) + time, 0);

export const getGifDurationFromUrl = (url) => new Promise((resolve, reject) => {
    const xmlHttpRequest = new XMLHttpRequest()
    xmlHttpRequest.open('GET', url, true);
    xmlHttpRequest.responseType = 'arraybuffer'
    xmlHttpRequest.onload = () => {
        const arrayBuffer = xmlHttpRequest.response;
        if (arrayBuffer) {
            const gif = parseGIF(arrayBuffer);
            const frames = decompressFrames(gif, true);
            resolve(calculateGifTime(frames) / 1000)
        } else {
            reject(new Error('gif has not content'))
        }
    }

    xmlHttpRequest.onerror = reject;

    xmlHttpRequest.send(null)
})
